module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"title":"查看评论详情","filtered_review_mismatch":"所选评价与当前筛选条件不符。已为您显示符合条件的第一条评价。","filtered_review_none":"当前筛选条件下没有符合条件的评价。请重置筛选条件后再试。"}}')
  delete Component.options._Ctor
}
